import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Mixin from 'components/common/Mixin'
import NewValuePropositionWrapper from './components/NewValuePropositionWrapper'

const MainHeadlineContent = ({
  placeholders: {
    heroContentBlock = []
  } = {}
}) =>
  <Wrapper>
    <NewValuePropositionWrapper />
    { heroContentBlock.slice(0, 1) }
  </Wrapper>

MainHeadlineContent.propTypes = {
  placeholders: PropTypes.shape()
}

export default MainHeadlineContent

const Wrapper = styled.div`
  position: relative;

  @media (min-width: 1024px) and (max-width: 1570px) {
    margin: 0 -50px;
  }

  &::after {
    content: "";
    position: absolute;
    bottom: -54px;
    z-index: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 80px;
    background: #fcfcfc;
    /* stylelint-disable-next-line property-no-vendor-prefix */
    -webkit-transform: skewY(-1.5deg);
    transform: skewY(-1.5deg);
    ${Mixin.desktopOnly()}
  }
`
